import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { FamilyInviationService } from 'src/app/Service/familyinviation.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';

@Component({
    selector: 'app-accept',
    templateUrl: './accept.component.html',
    styleUrls: [
        './accept.component.css',
        // './../questionnaires/questionnaires.component.css',
    ],
    standalone: false
})
export class AcceptComponent implements OnInit {
  @ViewChild('familyMembers') familyMembers;

  constructor(
    public auth: AuthService,
    public userService: UserService,
    private readonly loader: LoadingService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    public familyInviationService: FamilyInviationService,
    public modalService: NgbModal
  ) {
    //
    this.activatedRoute.params.subscribe((params) => {
      if (params)
        this.familyInviationService.getInvitationDetails(params['id']);
      else this.router.navigateByUrl('');
    });
  }

  ngOnInit(): void {
    if (this.userService.isLoggedin) {
      this.router.navigateByUrl('/user');
    } else {
      this.loader.HideLoading();
    }
  }
  showFamily() {
    this.modalService.open(this.familyMembers, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'sm',
      windowClass: 'accept-family-modal',
    });
  }
}
